import { nestPartials } from "../utils/misc";

/**
 * Represents the route name PARTIAL components for routes in Ember.  Nested
 * routes should be delineated by using a double underscore __ to show
 * nesting relationship.
 *
 * Ex: The message-center route has nested routes for /inbox + /archive.
 *     To represent these 3 distinct route names, we would set the following keys.
 *
 *     MESSAGE_CENTER = 'message-center'
 *     MESSAGE_CENTER__INBOX = 'inbox'
 *     MESSAGE_CENTER__ARCHIVE = 'archive'
 *
 *     Later, when wanting to reference the combined nested resource, you would just
 *     concatenate the values.  So if you wanted to get message-center.inbox, you would
 *     manually access via:
 *
 *     `${MESSAGE_CENTER}.{MESSAGE_CENTER__INBOX}`
 *
 * @const
 */
export const EMBER_ROUTE_PARTIALS = {
  ADMIN: 'admin',
  ADMIN__ACCOUNTING: 'accounting',
  ADMIN__ACCOUNTING__ACCOUNTS_AGING: 'accounts-aging',
  ADMIN__ACCOUNTING__ACCOUNTS_RECEIVABLE: 'accounts-receivable',
  ADMIN__ACCOUNTING__PAYIN: 'payin',
  ADMIN__ACCOUNTING__PAYIN__SH_INVOICE: 'sh-invoice',
  ADMIN__ACCOUNTING__PAYOUT: 'payout',
  ADMIN__ACCOUNTING__PAYOUT__SH_PAYMENT: 'sh-payment',
  ADMIN__BLASTER: 'blaster',
  ADMIN__CLASSIFICATION: 'classification',
  ADMIN__COMPANIES: 'companies',
  ADMIN__COMPANY: 'company',
  ADMIN__COMPANY__CREATE: 'create',
  ADMIN__CONTENT: 'content',
  ADMIN__LEGAL: 'legal',
  ADMIN__MASQUERADE: 'masquerade',
  ADMIN__REPORTS: 'reports',
  ADMIN__VETTING_QUEUE: 'vetting-queue',
  ADMIN__USER: 'user',
  ADMIN__USER__BILLING: 'billing',
  ADMIN__USER__RATE: 'rate',
  ADMIN__USERS: 'users',
  ADMIN__POSTINGS: 'postings',
  ADMIN__PROJECTS: 'projects',
  ALL_ROUTES: 'all-routes',
  BRAND: 'brand',
  BRAND__SIGNUP: 'signup',
  BRAND__SIGNUP__STEP: 'step',
  BRAND__SIGNUP__STEP__COMPANY_INFO: 'company-info',
  BRAND__SIGNUP__STEP__ABOUT_YOU: 'about-you',
  BRAND__SIGNUP__STEP__PAYMENT_METHOD: 'payment-method',
  BRAND__SIGNUP__STEP__VERIFY_EMAIL: 'verify-email',
  BRAND__SIGNUP__STEP__PENDING_APPROVAL: 'pending-approval',
  CONTRACTOR_AGREEMENT: 'contractor-agreement',
  DASHBOARD: 'dashboard',
  END_MASQUERADE: 'end-masquerade',
  INDEX: 'index',
  IFRAME: 'iframe',
  IFRAME__DIRECT_HIRE: 'direct-hire',
  JOIN_COMPANY: 'joincompany',
  MAINTENANCE: 'maintenance',
  MASTER_PUBLISHER_AGREEMENT: 'master-publisher-agreement',
  MESSAGE_CENTER: 'message-center',
  MESSAGE_CENTER__INBOX: 'inbox',
  MESSAGE_CENTER__ARCHIVE: 'archive',
  MESSAGE_CENTER__INBOX__THREAD: 'thread',
  MESSAGE_CENTER__ARCHIVE__THREAD: 'thread',
  COMPANY_ANALYTICS: 'reports',
  COMPANY_ANALYTICS__PROJECTS: 'projects',
  COMPANY_ANALYTICS__FREELANCERS: 'freelancers',
  COMPANY_ANALYTICS__INVOICES: 'invoices',
  COMPANY_ANALYTICS__CREDITS: 'company-credits',
  COMPANY_ANALYTICS__TOTALS: 'totals',
  COMPANY_PROFILE: 'company-profile',
  COMPANY_FREELANCER: 'user',
  COMPANY_VIEW: 'view',
  COMPLAINT_POLICY: 'complaint-policy',
  COPYRIGHT_POLICY: 'copyright-policy',
  OUT: 'out',
  PAGE_NOT_FOUND: '404',
  PEOPLE_CENTER: 'people-center',
  PEOPLE_CENTER__MY_NETWORK: 'my-network',
  PEOPLE_CENTER__SEARCH: 'search',
  PROJECT__CREATE: 'project-create',
  PROJECT__CREATE__FIND_FREELANCER: 'find-freelancer',
  PROJECT__CREATE__DIRECT: 'direct',
  PROJECT__DETAILS: 'project-details',
  PROJECT__DETAILS__ACTIVITY: 'activity',
  PROJECT__CANCELLATION: 'project-cancellation',
  PROJECT__CANCELLATION__CANCEL_SUBMITTED: 'cancel_submitted',
  PROJECT__CANCELLATION__CONFIRM: 'confirm',
  PROJECT__CANCELLATION__DETAILS: 'details',
  PROJECT__CANCELLATION__PAYMENT: 'payment',
  PROJECT__ADVANCE__APPROVE: 'approve',
  PROJECT__ADVANCE: 'project-advance',
  PROJECT__COMPLETE: 'project-completion',
  PROJECT__COMPLETE__PRIVATE_FEEDBACK: 'private-feedback',
  PROJECT__COMPLETE__PUBLIC_FEEDBACK: 'public-feedback',
  PROJECT__DETAILS__DETAILS: 'details',
  PROJECT__DETAILS__DELIVERABLES: 'deliverables',
  PROJECT__DETAILS__FILES: 'files',
  PROJECT__DETAILS__PAYMENT: 'payment',
  PROJECT__DETAILS__PITCH: 'pitch',
  POSTING: 'posting',
  POSTING__CREATE: 'posting-create',
  POSTING__CREATE__FIND_FREELANCERS: 'find-freelancer',
  POSTING__CREATE__PITCHES: 'pitch',
  POSTING__CREATE__SELECT: 'select',
  POSTING__CLOSE: 'close',
  POSTING__DECLINED: 'declined',
  POSTING__EDIT: 'edit',
  POSTING__HIRED: 'hired',
  POSTING__PENDING: 'pending',
  POSTING__APPLY: 'apply',
  POSTINGS: 'postings',
  POSTING__APP: 'app',
  POSTINGS__LIVE: 'live',
  POSTINGS__DRAFT: 'draft',
  POSTINGS__CLOSED: 'closed',
  POSTINGS__IN_REVIEW: 'in-review',
  POSTINGS__FIND_WORK: 'find-work',
  POSTINGS__FIND_WORK__RECOMMENDED: 'recommended',
  POSTINGS__FIND_WORK__OTHER: 'other',
  POSTINGS__FIND_WORK__SAVED: 'saved',
  POSTINGS__OTHER: 'other',
  POSTINGS__SEARCH: 'search',
  POSTINGS__RECOMMENDED: 'recommended',
  POSTINGS__APPLICATIONS: 'applications',
  POSTINGS__APPLICATIONS__HIRED: 'hired',
  POSTINGS__APPLICATIONS__SUBMITTED: 'submitted',
  PRIVACY: 'privacy', /* Opens externally in React Native (lack of navigation). */
  PRIVACY_POLICY: 'privacy-policy',
  PROJECTS: 'projects',
  PROJECTS__ACTIVE: 'active',
  PROJECTS__PENDING: 'pending',
  PROJECTS__ARCHIVED: 'archived',
  PROJECTS__IN_PROGRESS: 'in-progress',
  PROJECTS__COMPLETE: 'complete',
  PROJECTS__CANCELLED: 'cancelled',
  PROJECTS__SEARCH: 'search',
  PUBLIC: 'public',
  PROFILE: 'profile',
  REFERRAL: 'referral',
  REFERRAL__RECEIVE: 'receive',
  RESET_PASSWORD: 'reset-password',
  SETTINGS: 'settings',
  SETTINGS__NOTIFICATION_PREFERENCES: 'notification-preferences',
  SETTINGS__CREDENTIALS: 'credentials',
  SETTINGS__PAYOUT: 'payout',
  SETTINGS__PAYOUT__ADD_METHOD: 'add-method',
  SETTINGS__PAYOUT__ADD_METHOD__PERSONAL_INFO: 'personal-info',
  SETTINGS__PAYOUT__ADD_METHOD__TRANSFER_METHOD: 'transfer-method',
  SETTINGS__PAYOUT__ADD_METHOD__SELECT_METHOD: 'select-method',
  SETTINGS__PAYOUT__ADD_METHOD__PAYONEER_SETUP: 'payoneer-setup',
  SETTINGS__PAYOUT__PAYEE_VERIFICATION: 'payee-verification',
  SETTINGS__PROFILE: 'profile',
  SETTINGS__BACKGROUND: 'background',
  SETTINGS__OPTIONS: 'options',
  SETTINGS__RESET_EMAIL: 'reset-email',
  SIGNIN: 'signin',
  SIGNIN__SAML: 'saml',
  SIGNOUT: 'signout',
  SITE_CONFIG: 'site-config',
  START: 'start',
  TERMS_OF_SERVICE: 'termsofservice', /* Opens externally in React Native (lack of navigation). */
  UPGRADE: 'upgrade',
  USER_SIGNUP_BASE_PATH: 'user-signup',
  VERIFY_EMAIL: 'verify-email',
  SIGNUP: 'signup',
  SIGNUP__STEP: 'step',
  SIGNUP__STEP__PROFILE: 'profile',
  SIGNUP__STEP__BACKGROUND: 'background',
  SIGNUP__STEP__VERIFY_EMAIL: 'verify',
  SIGNUP__STEP__WORK: 'work',
  SIGNUP__STEP__DONE: 'done',
};


/**
 * Represents the fully qualified names of nested routes in Ember.  As compared with "Partials"
 * above, this is what would be used most often throughout the app.
 *
 * Ex: You've just laid out the nested route structure for Message Center and filled out the
 * appropriate partials in the EMBER_ROUTE_PARTIALS object.  To define those routes here, you
 * would use the same double underscore (__) pattern to delineate a nested partial, and would record
 * as follows
 *
 *   MESSAGE_CENTER__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, EMBER_ROUTE_PARTIALS.INDEX),
 *   MESSAGE_CENTER__INBOX: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX),
 *   MESSAGE_CENTER__INBOX__INDEX: nestPartials(
 *     EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
 *     EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX,
 *     EMBER_ROUTE_PARTIALS.INDEX
 *   ),
 *
 * @const
 */
export const EMBER_ROUTE_NAMES = {
  ADMIN: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN),

  ADMIN__ACCOUNTING: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING),
  ADMIN__ACCOUNTING__ACCOUNTS_AGING: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__ACCOUNTS_AGING),
  ADMIN__ACCOUNTING__ACCOUNTS_RECEIVABLE: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__ACCOUNTS_RECEIVABLE),
  ADMIN__ACCOUNTING__PAYIN: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYIN),
  ADMIN__ACCOUNTING__PAYIN__SH_INVOICE: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYIN__SH_INVOICE),
  ADMIN__ACCOUNTING__PAYOUT: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYOUT),
  ADMIN__ACCOUNTING__PAYOUT__SH_PAYMENT: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYOUT,
    EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYOUT__SH_PAYMENT),

  ADMIN__BLASTER: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__BLASTER),
  ADMIN__CLASSIFICATION: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__CLASSIFICATION),
  ADMIN__COMPANIES: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__COMPANIES),
  ADMIN__VETTING_QUEUE: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__VETTING_QUEUE),
  ADMIN__COMPANY: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__COMPANY),
  ADMIN__COMPANY__CREATE: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__COMPANY,
    EMBER_ROUTE_PARTIALS.ADMIN__COMPANY__CREATE),

  ADMIN__CONTENT: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__CONTENT),

  ADMIN__LEGAL: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__LEGAL),

  ADMIN__MASQUERADE: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__MASQUERADE),

  ADMIN__REPORTS: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN__REPORTS),

  ADMIN__USER: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__USER),
  ADMIN__USER__BILLING: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__USER,
    EMBER_ROUTE_PARTIALS.ADMIN__USER__BILLING,
  ),
  ADMIN__USER__RATE: nestPartials(
    EMBER_ROUTE_PARTIALS.ADMIN,
    EMBER_ROUTE_PARTIALS.ADMIN__USER,
    EMBER_ROUTE_PARTIALS.ADMIN__USER__RATE,
  ),

  ADMIN__USERS: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__USERS),
  ADMIN__POSTINGS: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__POSTINGS),
  ADMIN__PROJECTS: nestPartials(EMBER_ROUTE_PARTIALS.ADMIN, EMBER_ROUTE_PARTIALS.ADMIN__PROJECTS),

  ALL_ROUTES: EMBER_ROUTE_PARTIALS.ALL_ROUTES,

  BRAND: nestPartials(EMBER_ROUTE_PARTIALS.BRAND),
  BRAND__SIGNUP: nestPartials(EMBER_ROUTE_PARTIALS.BRAND, EMBER_ROUTE_PARTIALS.BRAND__SIGNUP),
  BRAND__SIGNUP__STEP: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
  ),
  BRAND__SIGNUP__STEP__COMPANY_INFO: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__COMPANY_INFO
  ),
  BRAND__SIGNUP__STEP__ABOUT_YOU: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__ABOUT_YOU,
  ),
  BRAND__SIGNUP__STEP__PAYMENT_METHOD: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__PAYMENT_METHOD,
  ),
  BRAND__SIGNUP__STEP__VERIFY_EMAIL: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__VERIFY_EMAIL,
  ),
  BRAND__SIGNUP__STEP__PENDING_APPROVAL: nestPartials(
    EMBER_ROUTE_PARTIALS.BRAND,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP,
    EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__PENDING_APPROVAL,
  ),

  COMPANY_ANALYTICS: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS),
  COMPANY_ANALYTICS__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.INDEX),
  COMPANY_ANALYTICS__PROJECTS: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__PROJECTS),
  COMPANY_ANALYTICS__FREELANCERS: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__FREELANCERS),
  COMPANY_ANALYTICS__INVOICES: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__INVOICES),
  COMPANY_ANALYTICS__CREDITS: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__CREDITS),
  COMPANY_ANALYTICS__TOTALS: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__TOTALS),

  COMPANY_PROFILE: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_PROFILE),
  COMPANY_FREELANCER: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_PROFILE, EMBER_ROUTE_PARTIALS.COMPANY_FREELANCER),
  COMPANY_VIEW: nestPartials(EMBER_ROUTE_PARTIALS.COMPANY_PROFILE, EMBER_ROUTE_PARTIALS.COMPANY_VIEW),

  COMPLAINT_POLICY: EMBER_ROUTE_PARTIALS.COMPLAINT_POLICY,
  CONTRACTOR_AGREEMENT: EMBER_ROUTE_PARTIALS.CONTRACTOR_AGREEMENT,
  COPYRIGHT_POLICY: EMBER_ROUTE_PARTIALS.COPYRIGHT_POLICY,

  DASHBOARD: EMBER_ROUTE_PARTIALS.DASHBOARD,

  IFRAME: EMBER_ROUTE_PARTIALS.IFRAME,
  IFRAME__DIRECT_HIRE: nestPartials(EMBER_ROUTE_PARTIALS.IFRAME, EMBER_ROUTE_PARTIALS.IFRAME__DIRECT_HIRE),

  JOIN_COMPANY: EMBER_ROUTE_PARTIALS.JOIN_COMPANY,

  MESSAGE_CENTER: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER),
  MESSAGE_CENTER__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, EMBER_ROUTE_PARTIALS.INDEX),
  MESSAGE_CENTER__INBOX: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX),
  MESSAGE_CENTER__INBOX__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX,
    EMBER_ROUTE_PARTIALS.INDEX
  ),
  MESSAGE_CENTER__ARCHIVE: nestPartials(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE),
  MESSAGE_CENTER__ARCHIVE__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE,
    EMBER_ROUTE_PARTIALS.INDEX
  ),
  MESSAGE_CENTER__INBOX__THREAD: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX__THREAD
  ),
  MESSAGE_CENTER__INBOX__THREAD__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX__THREAD,
    EMBER_ROUTE_PARTIALS.INDEX
  ),
  MESSAGE_CENTER__ARCHIVE__THREAD: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE__THREAD
  ),
  MESSAGE_CENTER__ARCHIVE__THREAD__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE,
    EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE__THREAD,
    EMBER_ROUTE_PARTIALS.INDEX
  ),

  PAGE_NOT_FOUND: EMBER_ROUTE_PARTIALS.PAGE_NOT_FOUND,

  PEOPLE_CENTER: nestPartials(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER),
  PEOPLE_CENTER__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER, EMBER_ROUTE_PARTIALS.INDEX),
  PEOPLE_CENTER__MY_NETWORK: nestPartials(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER, EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__MY_NETWORK),
  PEOPLE_CENTER__MY_NETWORK__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.PEOPLE_CENTER,
    EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__MY_NETWORK,
    EMBER_ROUTE_PARTIALS.INDEX
  ),

  PEOPLE_CENTER__SEARCH: nestPartials(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER, EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__SEARCH),
  PEOPLE_CENTER__SEARCH__INDEX: nestPartials(
    EMBER_ROUTE_PARTIALS.PEOPLE_CENTER,
    EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__SEARCH,
    EMBER_ROUTE_PARTIALS.INDEX
  ),

  MAINTENANCE: EMBER_ROUTE_PARTIALS.MAINTENANCE,
  MASTER_PUBLISHER_AGREEMENT: EMBER_ROUTE_PARTIALS.MASTER_PUBLISHER_AGREEMENT,

  OUT: nestPartials(EMBER_ROUTE_PARTIALS.OUT),

  PROJECT__CREATE__FIND_FREELANCER: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CREATE, EMBER_ROUTE_PARTIALS.PROJECT__CREATE__FIND_FREELANCER),
  PROJECT__CREATE__DIRECT: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CREATE, EMBER_ROUTE_PARTIALS.PROJECT__CREATE__DIRECT),

  PROJECT__DETAILS: EMBER_ROUTE_PARTIALS.PROJECT__DETAILS,
  PROJECT__DETAILS__ACTIVITY: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__ACTIVITY),
  PROJECT__DETAILS__DETAILS: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__DETAILS),
  PROJECT__DETAILS__DELIVERABLES: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__DELIVERABLES),
  PROJECT__DETAILS__FILES: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__FILES),
  PROJECT__DETAILS__PAYMENT: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__PAYMENT),
  PROJECT__DETAILS__PITCH: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__PITCH),

  PROJECT__CANCELLATION: EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION,
  PROJECT__CANCELLATION__CANCEL_SUBMITTED: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION, EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__CANCEL_SUBMITTED),
  PROJECT__CANCELLATION__CONFIRM: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION, EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__CONFIRM),
  PROJECT__CANCELLATION__DETAILS: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION, EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__DETAILS),
  PROJECT__CANCELLATION__PAYMENT: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION, EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__PAYMENT),

  PROJECT__COMPLETE: EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE,
  PROJECT__COMPLETE__PRIVATE_FEEDBACK: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE, EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE__PRIVATE_FEEDBACK),
  PROJECT__COMPLETE__PUBLIC_FEEDBACK: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE, EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE__PUBLIC_FEEDBACK),

  PROJECT__ADVANCE: EMBER_ROUTE_PARTIALS.PROJECT__ADVANCE,
  PROJECT__ADVANCE__APPROVE: nestPartials(EMBER_ROUTE_PARTIALS.PROJECT__ADVANCE, EMBER_ROUTE_PARTIALS.PROJECT__ADVANCE__APPROVE),

  POSTING__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.INDEX),
  POSTING__APP: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__APP),
  POSTING__CLOSE: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__CLOSE),
  POSTING__DECLINED: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__DECLINED),
  POSTING__EDIT: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__EDIT),
  POSTING__HIRED: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__HIRED),
  POSTING__PENDING: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__PENDING),
  POSTING__APPLY: nestPartials(EMBER_ROUTE_PARTIALS.POSTING, EMBER_ROUTE_PARTIALS.POSTING__APPLY),

  POSTING__CREATE: EMBER_ROUTE_PARTIALS.POSTING__CREATE,
  POSTING__CREATE__FIND_FREELANCERS: nestPartials(EMBER_ROUTE_PARTIALS.POSTING__CREATE, EMBER_ROUTE_PARTIALS.POSTING__CREATE__FIND_FREELANCERS),
  POSTING__CREATE__PITCHES: nestPartials(EMBER_ROUTE_PARTIALS.POSTING__CREATE, EMBER_ROUTE_PARTIALS.POSTING__CREATE__PITCHES),
  POSTING__CREATE__SELECT: nestPartials(EMBER_ROUTE_PARTIALS.POSTING__CREATE, EMBER_ROUTE_PARTIALS.POSTING__CREATE__SELECT),

  POSTINGS__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.INDEX),
  POSTINGS__LIVE: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__LIVE),
  POSTINGS__DRAFT: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__DRAFT),
  POSTINGS__CLOSED: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__CLOSED),
  POSTINGS__IN_REVIEW: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__IN_REVIEW),

  POSTINGS__FIND_WORK: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK),
  POSTINGS__FIND_WORK__RECOMMENDED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__RECOMMENDED
  ),
  POSTINGS__FIND_WORK__OTHER: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__OTHER
  ),
  POSTINGS__FIND_WORK__SAVED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK,
    EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__SAVED
  ),
  POSTINGS__OTHER: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__OTHER),
  POSTINGS__RECOMMENDED: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__RECOMMENDED),
  POSTINGS__SEARCH: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__SEARCH),

  POSTINGS__APPLICATIONS: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS),
  POSTINGS__APPLICATIONS__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS, EMBER_ROUTE_PARTIALS.INDEX),
  POSTINGS__APPLICATIONS__HIRED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__HIRED
  ),
  POSTINGS__APPLICATIONS__SUBMITTED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__SUBMITTED
  ),

  POSTINGS__APPLICATIONS: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS),
  POSTINGS__APPLICATIONS__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.POSTINGS, EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS, EMBER_ROUTE_PARTIALS.INDEX),
  POSTINGS__APPLICATIONS__HIRED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__HIRED
  ),
  POSTINGS__APPLICATIONS__SUBMITTED: nestPartials(
    EMBER_ROUTE_PARTIALS.POSTINGS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS,
    EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__SUBMITTED
  ),

  PRIVACY: EMBER_ROUTE_PARTIALS.PRIVACY,
  PRIVACY_POLICY: EMBER_ROUTE_PARTIALS.PRIVACY_POLICY,

  PROJECTS__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.INDEX),
  PROJECTS__IN_PROGRESS: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__IN_PROGRESS),
  PROJECTS__COMPLETE: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__COMPLETE),
  PROJECTS__CANCELLED: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__CANCELLED),
  PROJECTS__ACTIVE: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__ACTIVE),
  PROJECTS__PENDING: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__PENDING),
  PROJECTS__ARCHIVED: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__ARCHIVED),
  PROJECTS__SEARCH: nestPartials(EMBER_ROUTE_PARTIALS.PROJECTS, EMBER_ROUTE_PARTIALS.PROJECTS__SEARCH),

  PROFILE: EMBER_ROUTE_PARTIALS.PROFILE,

  REFERRAL: EMBER_ROUTE_PARTIALS.REFERRAL,
  REFERRAL__RECEIVE: nestPartials(EMBER_ROUTE_PARTIALS.REFERRAL, EMBER_ROUTE_PARTIALS.REFERRAL__RECEIVE),

  RESET_PASSWORD: EMBER_ROUTE_PARTIALS.RESET_PASSWORD,

  SITE_CONFIG: nestPartials(EMBER_ROUTE_PARTIALS.SITE_CONFIG),
  SITE_CONFIG__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.SITE_CONFIG, EMBER_ROUTE_PARTIALS.INDEX),

  SETTINGS: EMBER_ROUTE_PARTIALS.SETTINGS,
  SETTINGS__BACKGROUND: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__BACKGROUND),
  SETTINGS__OPTIONS: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__OPTIONS),
  SETTINGS__NOTIFICATION_PREFERENCES: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__NOTIFICATION_PREFERENCES),
  SETTINGS__CREDENTIALS: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__CREDENTIALS),
  SETTINGS__PAYOUT: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT),
  SETTINGS__PAYOUT__ADD_METHOD: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD),
  SETTINGS__PAYOUT__ADD_METHOD__PERSONAL_INFO: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__PERSONAL_INFO),
  SETTINGS__PAYOUT__ADD_METHOD__TRANSFER_METHOD: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__TRANSFER_METHOD),
  SETTINGS__PAYOUT__ADD_METHOD__SELECT_METHOD: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__SELECT_METHOD),
  SETTINGS__PAYOUT__ADD_METHOD__PAYONEER_SETUP: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__PAYONEER_SETUP),
  SETTINGS__PAYOUT__PAYEE_VERIFICATION: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__PAYEE_VERIFICATION),
  SETTINGS__PROFILE: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__PROFILE),
  SETTINGS__RESET_EMAIL: nestPartials(EMBER_ROUTE_PARTIALS.SETTINGS, EMBER_ROUTE_PARTIALS.SETTINGS__RESET_EMAIL),

  START: EMBER_ROUTE_PARTIALS.START,
  SIGNIN: EMBER_ROUTE_PARTIALS.SIGNIN,
  SIGNIN__SAML: nestPartials(EMBER_ROUTE_PARTIALS.SIGNIN, EMBER_ROUTE_PARTIALS.SIGNIN__SAML),
  SIGNOUT: EMBER_ROUTE_PARTIALS.SIGNOUT,
  TERMS_OF_SERVICE: EMBER_ROUTE_PARTIALS.TERMS_OF_SERVICE,
  UPGRADE: EMBER_ROUTE_PARTIALS.UPGRADE,
  VERIFY_EMAIL: EMBER_ROUTE_PARTIALS.VERIFY_EMAIL,

  SIGNUP: EMBER_ROUTE_PARTIALS.SIGNUP,
  SIGNUP__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.INDEX),
  SIGNUP__STEP: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP),
  SIGNUP__STEP__INDEX: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.INDEX),
  SIGNUP__STEP__PROFILE: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP__PROFILE),
  SIGNUP__STEP__BACKGROUND: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP__BACKGROUND),
  SIGNUP__STEP__VERIFY_EMAIL: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP__VERIFY_EMAIL),
  SIGNUP__STEP__WORK: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP__WORK),
  SIGNUP__STEP__DONE: nestPartials(EMBER_ROUTE_PARTIALS.SIGNUP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP, EMBER_ROUTE_PARTIALS.SIGNUP__STEP__DONE),
};
